import {VersionVariants} from '@jobseeker/lotus/enums';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
import dynamic from 'next/dynamic';
import type {mediaCardProps} from './type';
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = dynamic(() => import('./V1'));
componentMap[VersionVariants.VERSION_TWO] = dynamic(() => import('./V2'));

const MediaCard = (props: mediaCardProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default MediaCard;
